<template>
    <header class="fixed z-50 w-full bg-white" :class="url_data === '' ? '' : 'shadow-lg' ">
        <div class="flex items-center justify-between py-4 -mt-1">
            <div class="pl-8 sm:pl-16">
                <a href="/">
                    <img src="/assets/osm-logo.svg" alt="OSM" class="max-h-10">
                </a>
            </div>
            <div class="hidden md:block">
                <nav class="">
                    <ul class="flex items-center justify-end font-semibold uppercase">
                        <li class="px-6">
                            <a :class="url_data == '' ? 'router-link-exact-active' : ''" class="menuItem-active-link" href="/">home</a>
                        </li>
                        <li class="px-6">
                            <a :class="url_data == 'events' || url_data == 'event' ? 'router-link-exact-active' : ''" class="menuItem-active-link" href="/events">eventi</a>
                        </li>
                        <li class="px-6">
                            <a :class="url_data == 'categories' || url_data == 'category' ? 'router-link-exact-active' : ''" class="menuItem-active-link" href="/categories">temi</a>
                        </li>
                        <li class="px-6">
                            <a :class="url_data == 'speakers' || url_data == 'speaker' ? 'router-link-exact-active' : ''" class="menuItem-active-link" href="/speakers">speaker</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="md:hidden">
                <mobile-menu></mobile-menu>
            </div>
        </div>
    </header>
</template>

<script>
    import MobileMenu from '../Components/MobileMenu'

    export default {
        name: 'navbar',
        components: {
            MobileMenu
        },
        data(){
            return{
                url_data: null
            };
        },
        mounted(){
            this.url_data = window.location.pathname.split('/')[1];
        }
    }
</script>

<style scoped>
    .router-link-exact-active.menuItem-active-link{
        color: white;
        border: 1px solid #db2777;
        padding: 3px 15px 5px 15px;
        background-color: #db2777;
        border-radius: 12px;
    }
</style>